export default {
    serial: 80,
    action: 120,
    status: 100
}